export enum FeeTypeEnum {
    BASIS_POINTS = 'B',
    FIXED_AMOUNT = 'F',
    PERCENTAGE = 'P'
}

type FeeTypeMap = Record<
    FeeTypeEnum,
    { displayValue: string }
>;

export const FeeTypeMap: FeeTypeMap = {
    [FeeTypeEnum.BASIS_POINTS]: { displayValue: 'Basis Points' },
    [FeeTypeEnum.FIXED_AMOUNT]: { displayValue: 'Fixed Amount' },
    [FeeTypeEnum.PERCENTAGE]: { displayValue: 'Percentage' }
};